import React, { useState } from 'react';
import SecondaryButton from '../Button/SecondaryButton';
import FormWrapper from '../FormWrapper/FormWrapper';
import TextAreaComponent from '../TextInput/TextAreaComponent';
import TitleComponent from '../Title/TitleComponent';
import AutocompleteComponent from '../Autcomplete/AutocompleteComponent';
import { API_URL } from '../../../../utils/constants';

export const ExportForm = ({
  title,
  description,
  input,
  setInput,
  onExport,
  buttonTitle,
  buttonIcon,
  isSelectableMargins = false,
}) => {
  const [selectedMargin, setSelectedMargin] = useState(null);

  const handleExport = () => {
    onExport(selectedMargin);
  };

  return (
    <FormWrapper width="100%">
      <form>
        <TitleComponent Heading="h6" title={title} />
        <div style={{ color: '#343434', lineHeight: '17px', fontSize: '14px', textAlign: 'center' }}>
          <span>{description}</span>
          <br />
          <span>
            Use command{' '}
            <pre style={{ display: 'inline', fontWeight: 'bold' }}>
              =TEXTJOIN(&quot;,&quot;,TRUE,A1:A20)
            </pre>{' '}
            to convert a column in excel to comma-separated list to paste here
          </span>
          <br />
          <br />
        </div>
        <TextAreaComponent
          value={input}
          onChange={(e) => setInput(e.target.value)}
          name={''}
          onBlur={undefined}
          cols={12}
          rows={4}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <SecondaryButton icon={buttonIcon} onClick={handleExport} title={buttonTitle} />
          {isSelectableMargins && (
            <AutocompleteComponent
              url={`${API_URL}/margins/get-all`}
              name="marginId"
              label="Select Margin"
              onChange={(field, value) => setSelectedMargin(value)}
              getOptionLabel={(option) => `${option.country.name}`}
            />
          )}
        </div>
      </form>
    </FormWrapper>
  );
};